<template>
  <div class="padres-container">

    <!-- FONDO DEGRADADO SATINADO CON TEXTURA SUAVE -->
    <div class="fondo-satinado-luxury"></div>

    <!-- CONTADOR -->
    <div ref="contadorRef" class="contador-container">
      <!-- CENEFA ONDULADA SUPERIOR -->
      <div class="cenefa cenefa-superior">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M0,0 C150,90 350,-40 500,60 C650,160 900,10 1200,40 L1200,0 L0,0 Z" fill="#e6b1c4"></path>
        </svg>
      </div>

      <div class="frase-container">
        <h2 class="frase linea1">¡Cada segundo</h2>
        <h2 class="frase linea2">más cerca</h2>
        <p class="frase linea3">de mi gran día!</p>
      </div>

      <!-- SEPARADOR CON IMAGEN -->
      <div ref="separadorRef" class="separador-wrapper">
        <img src="@/assets/ssss.png" alt="Separador decorativo" class="separador-img" />
      </div>

      <div class="contador-titulo">
        <span ref="soloRef" class="solo">Solo</span>
        <span ref="faltanRef" class="faltan">Faltan</span>
      </div>

      <div ref="flechaRef" class="flecha-wrapper">
        <img src="@/assets/15.avif" alt="Flecha decorativa" class="flecha-img" />
      </div>

      <div class="contador-numeros">
        <div ref="tiempoRef1" class="tiempo">
          <span class="numero">{{ dias }}</span>
          <span class="etiqueta">Días</span>
        </div>
        <div ref="tiempoRef2" class="tiempo">
          <span class="numero">{{ horas }}</span>
          <span class="etiqueta">Horas</span>
        </div>
        <div ref="tiempoRef3" class="tiempo">
          <span class="numero">{{ minutos }}</span>
          <span class="etiqueta">Minutos</span>
        </div>
        <div ref="tiempoRef4" class="tiempo">
          <span class="numero">{{ segundos }}</span>
          <span class="etiqueta">Segundos</span>
        </div>
      </div>

      <!-- CENEFA ONDULADA INFERIOR -->
      <div class="cenefa cenefa-inferior">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M0,80 C300,140 600,10 900,100 C1050,145 1150,70 1200,80 L1200,120 L0,120 Z" fill="#e6b1c4"></path>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'BienvenidaPadresPage',
  setup() {
    const contadorRef = ref(null)
    const separadorRef = ref(null)
    const soloRef = ref(null)
    const faltanRef = ref(null)
    const flechaRef = ref(null)
    const tiempoRef1 = ref(null)
    const tiempoRef2 = ref(null)
    const tiempoRef3 = ref(null)
    const tiempoRef4 = ref(null)

    const dias = ref('00')
    const horas = ref('00')
    const minutos = ref('00')
    const segundos = ref('00')

    let timerId = null

    const cuentaAtras = () => {
      const evento = new Date('2026-10-09T18:00:00')
      const tick = () => {
        const ahora = new Date()
        const diferencia = evento - ahora
        if (diferencia <= 0) {
          dias.value = horas.value = minutos.value = segundos.value = '00'
          clearInterval(timerId)
          return
        }
        dias.value = String(Math.floor(diferencia / (1000 * 60 * 60 * 24))).padStart(2, '0')
        horas.value = String(Math.floor((diferencia / (1000 * 60 * 60)) % 24)).padStart(2, '0')
        minutos.value = String(Math.floor((diferencia / (1000 * 60)) % 60)).padStart(2, '0')
        segundos.value = String(Math.floor((diferencia / 1000) % 60)).padStart(2, '0')
      }
      tick()
      timerId = setInterval(tick, 1000)
    }

    onMounted(async () => {
      await nextTick()
      cuentaAtras()

      // ESTADO INICIAL
      gsap.set(contadorRef.value, { autoAlpha: 0, y: -40 })
      gsap.set(separadorRef.value, { autoAlpha: 0, scale: 0.85, y: -10 })
      gsap.set([soloRef.value, faltanRef.value], { autoAlpha: 0, y: -25 })
      gsap.set(flechaRef.value, { autoAlpha: 0, y: -20, scale: 0.85 })
      gsap.set(
        [tiempoRef1.value, tiempoRef2.value, tiempoRef3.value, tiempoRef4.value],
        { autoAlpha: 0, y: -20 }
      )

      const el = contadorRef.value

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          // 1. Aparición del contenedor
          tl.to(el, {
            autoAlpha: 1,
            y: 0,
            duration: 0.8,
            ease: 'back.out(1.2)'
          })

          // 2. Revelación de la imagen del separador
          tl.to(separadorRef.value, {
            autoAlpha: 1,
            scale: 1,
            y: 0,
            duration: 0.6,
            ease: 'back.out(1.4)'
          }, '-=0.3')

          // 3. Textos "Solo Faltan"
          tl.to(soloRef.value, {
            autoAlpha: 1,
            y: 0,
            duration: 0.5
          }, '-=0.3')

          tl.to(faltanRef.value, {
            autoAlpha: 1,
            y: 0,
            duration: 0.5
          }, '-=0.35')

          // 4. Flecha
          tl.to(flechaRef.value, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 0.6,
            ease: 'back.out(1.5)'
          }, '-=0.2')

          // 5. Bloques del contador
          tl.to(
            [tiempoRef1.value, tiempoRef2.value, tiempoRef3.value, tiempoRef4.value],
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.5,
              stagger: 0.1
            },
            '-=0.2'
          )

          // Animaciones ambientales
          gsap.to(el, {
            scale: 1.008,
            duration: 3.5,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut'
          })

          gsap.to(flechaRef.value, {
            y: '+=5',
            duration: 2,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut',
            delay: 0.5
          })

          io.disconnect()
        })
      }, { threshold: 0.25 })

      if (el) io.observe(el)
    })

    onUnmounted(() => {
      if (timerId) clearInterval(timerId)
    })

    return {
      contadorRef,
      separadorRef,
      soloRef,
      faltanRef,
      flechaRef,
      tiempoRef1,
      tiempoRef2,
      tiempoRef3,
      tiempoRef4,
      dias,
      horas,
      minutos,
      segundos
    }
  }
}
</script>

<style scoped>
/* =========================
   CONTENEDOR GENERAL
========================= */
.padres-container {
  position: relative;
  width: 100%;
  min-height: 45vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  padding: 40px 0;
}

/* =========================
   FONDO LUXURY SATINADO
========================= */
.fondo-satinado-luxury {
  position: absolute;
  inset: 0;
  z-index: 0;
  background: radial-gradient(
    circle at 50% 50%,
    #2c2b2c 0%,
    #262525 50%,
    #181717 100%
  );
}

/* =========================
   CONTENEDOR DEL CONTADOR
========================= */
.contador-container {
  position: relative;
  z-index: 2;
  width: min(92vw, 520px);
  padding: 50px 20px 55px;
  text-align: center;
  border-radius: 16px;
  opacity: 0;
  will-change: transform, opacity;
}

/* =========================
   FRASE SUPERIOR
========================= */
.frase-container {
  margin-bottom: 8px;
}

.frase {
  color: #e6b1c4 !important;
  margin: 0;
  line-height: 1.25;
}

.frase.linea1,
.frase.linea2 {
  font-family: 'Playfair Display', serif;
  font-size: clamp(22px, 5.5vw, 26px);
  font-weight: 500;
}

.frase.linea3 {
  font-family: 'Playfair Display', serif;
  font-size: clamp(16px, 4vw, 18px);
  font-style: italic;
  margin-top: 4px;
}

/* =========================
   SEPARADOR CON IMAGEN
========================= */
.separador-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 14px auto 8px;
  will-change: transform, opacity;
}

.separador-img {
  width: min(65vw, 220px);
  height: auto;
  object-fit: contain;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.08));
}

/* =========================
   TÍTULO SOLO / FALTAN
========================= */
.contador-titulo {
  margin-top: 6px;
  margin-bottom: 6px;
}

.contador-titulo .solo {
  font-family: 'Pinyon Script', 'Great Vibes', cursive;
  font-size: clamp(34px, 8vw, 42px);
  display: block;
  color: #fefefe !important;
  line-height: 0.9;
  opacity: 0;
}

.contador-titulo .faltan {
  font-family: 'Playfair Display', serif;
  font-size: clamp(32px, 8.5vw, 40px);
  letter-spacing: 2px;
  text-transform: uppercase;
  display: block;
  color: #f5f2f4 !important;
  font-weight: 600;
  opacity: 0;
}

/* =========================
   FLECHA
========================= */
.flecha-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 8px 0 16px;
}
.flecha-img {
  width: 28px;
  height: auto;
  opacity: 0.85;
  /* Forzar color blanco absoluto + sombra sutil */
  filter: brightness(0) invert(1) drop-shadow(0 2px 4px rgba(0, 0, 0, 0.15));
}

/* =========================
   CONTADOR NUMÉRICO
========================= */
.contador-numeros {
  display: flex;
  justify-content: space-around;
  gap: 10px;
  padding: 8px 4px;
}

.tiempo {
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  will-change: transform, opacity;
}

.numero {
  font-size: clamp(32px, 8vw, 42px);
  font-weight: 500;
  font-family: 'Playfair Display', serif;
  color: #f8f5f6 !important;
  line-height: 1;
}

.etiqueta {
  font-size: clamp(11px, 2.8vw, 13px);
  font-family: 'Montserrat', sans-serif;
  margin-top: 6px;
  color: #f4f2f3 !important;
  letter-spacing: 1.5px;
  text-transform: uppercase;
  font-weight: 500;
}

/* =========================
   CENEFAS ONDULADAS ELEGANTES (SVG)
========================= */
.cenefa {
  position: absolute;
  left: 0;
  width: 100%;
  height: 35px;
  overflow: hidden;
  pointer-events: none;
  z-index: 3;
}

.cenefa svg {
  width: 100%;
  height: 100%;
  display: block;
}

.cenefa-superior {
  top: 0;
  transform: translateY(-99%);
}

.cenefa-inferior {
  bottom: 0;
  transform: translateY(99%);
}

/* =========================
   RESPONSIVE
========================= */
@media (max-width: 420px) {
  .contador-numeros { gap: 4px; }
  .contador-container { padding: 40px 12px 45px; }
  .separador-img { width: 180px; }
}
</style>